import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import "./assets/style.css";
// import Markdown from 'vue3-markdown-it';

loadFonts();

createApp(App).use(router).use(vuetify).use().mount("#app");
